module.exports = __webpack_public_path__ + "img/1st_wt.7be08124.png";